module.exports = __webpack_public_path__ + "static/media/4-Anunciarlote.8ae9e5ca.jpg";